import { render, staticRenderFns } from "./MbContentInfoModal.vue?vue&type=template&id=02998982&scoped=true&"
import script from "./MbContentInfoModal.vue?vue&type=script&lang=js&"
export * from "./MbContentInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./MbContentInfoModal.vue?vue&type=style&index=0&id=02998982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02998982",
  null
  
)

export default component.exports